export default {
  props: {
    width: {
      type: String,
      default: '700px'
    },
    label: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    className: {
      type: String,
      default: ''
    },
    hint: {
      type: Boolean,
      default: false
    },
    closable: {
      type: Boolean,
      default: true
    },
    before: {
      type: Boolean,
      default: false
    },
    value: {
      type: Boolean,
      default: false
    },
    footer: {
      type: Boolean,
      default: true
    },
    body: {
      type: Boolean,
      default: false
    },
    'button-full': {
      type: Boolean,
      default: false
    },
    confirm: {
      type: [Boolean, String],
      default: false
    },
    cancel: {
      type: [Boolean, String],
      default: false
    }
  },
  data: function data() {
    return {
      isShow: false,
      position: {
        x: 0,
        y: 0
      },
      maximizedToggle: false
    };
  },
  watch: {
    value: {
      handler: function handler(val) {
        this.isShow = val;
      },
      immediate: true
    },
    isShow: function isShow(val) {
      if (!val) {
        this.position = this.$options.data().position;
        this.$emit('cancel');
      }
      this.$emit('input', val);
    },
    maximizedToggle: function maximizedToggle(val) {
      if (val) {
        this.resetData('position');
      }
    }
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    userHasPanned: function userHasPanned(e) {
      if (this.maximizedToggle) return;
      this.position.x += e.delta.x;
      this.position.y += e.delta.y;
    },
    trigger: function trigger() {
      this.isShow = !this.isShow;
      return this.isShow;
    },
    onClick: function onClick() {
      var _this = this;
      this.$emit('ok', function (res) {
        if (res) {
          _this.isShow = false;
        }
      });
    },
    handleClose: function handleClose(done) {
      if (this.before) {
        this.$emit('before-close', done);
      } else {
        if (this.hint) {
          this.$confirm('确认关闭？').then(function (_) {
            done();
          }).catch(function (_) {});
        } else {
          done();
        }
      }
    }
  }
};